/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsLinksOptions
 */
export interface FxIdDomainSettingsLinksOptions {
    /**
     * Если указано, то будет использоваться в местах где отображается ссылка на дискод в виде QR кода в веб версии
     * @type {string}
     * @memberof FxIdDomainSettingsLinksOptions
     */
    DiscordQrCodeImageUrl?: string | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsLinksOptions interface.
 */
export function instanceOfFxIdDomainSettingsLinksOptions(value: object): value is FxIdDomainSettingsLinksOptions {
    return true;
}

export function FxIdDomainSettingsLinksOptionsFromJSON(json: any): FxIdDomainSettingsLinksOptions {
    return FxIdDomainSettingsLinksOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsLinksOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsLinksOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'DiscordQrCodeImageUrl': json['DiscordQrCodeImageUrl'] == null ? undefined : json['DiscordQrCodeImageUrl'],
    };
}

export function FxIdDomainSettingsLinksOptionsToJSON(json: any): FxIdDomainSettingsLinksOptions {
    return FxIdDomainSettingsLinksOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsLinksOptionsToJSONTyped(value?: FxIdDomainSettingsLinksOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DiscordQrCodeImageUrl': value['DiscordQrCodeImageUrl'],
    };
}

